export default __webpack_public_path__ + "static/media/DR-CHAITHRA-SHENOY-MD.d10859bd.jpg";